import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function HomePage() {
  const [isScrolled, setIsScrolled] = useState(false);

  // スクロール監視
  useState(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  });

  return (
    <div className="min-h-screen bg-white">
      {/* ナビゲーション */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-lg' : 'bg-transparent'}`}>
        <div className="max-w-[1600px] mx-auto px-4 md:px-8 py-4 md:py-6 flex items-center justify-between">
          <div className="flex items-center gap-2 md:gap-3">
            <div className="w-8 h-8 md:w-12 md:h-12 flex items-center justify-center">
              <img src="https://static.readdy.ai/image/2742a16e19e552b156a048de837759a0/721313bee9e9ad322b7dd57b3ac95a66.png" alt="万燈ロゴ" className="w-full h-full object-contain" />
            </div>
            <span className={`text-lg md:text-2xl font-bold tracking-wider ${isScrolled ? 'text-[#0A1628]' : 'text-white'}`} style={{ fontFamily: "'Noto Serif JP', serif" }}>万燈</span>
          </div>
          <div className="hidden md:flex items-center gap-8">
            <a href="#about" className={`text-sm font-medium transition-colors ${isScrolled ? 'text-[#0A1628] hover:text-[#D4AF37]' : 'text-white hover:text-[#D4AF37]'}`}>サービス概要</a>
            <a href="#strategy" className={`text-sm font-medium transition-colors ${isScrolled ? 'text-[#0A1628] hover:text-[#D4AF37]' : 'text-white hover:text-[#D4AF37]'}`}>戦略</a>
            <a href="#comparison" className={`text-sm font-medium transition-colors ${isScrolled ? 'text-[#0A1628] hover:text-[#D4AF37]' : 'text-white hover:text-[#D4AF37]'}`}>比較表</a>
            <a href="#voice" className={`text-sm font-medium transition-colors ${isScrolled ? 'text-[#0A1628] hover:text-[#D4AF37]' : 'text-white hover:text-[#D4AF37]'}`}>お客様の声</a>
            <a
              href="https://carpartnershub.com/fm/29419/TjLxHRUK"
              target="_blank"
              rel="noopener noreferrer"
              className={`px-5 py-2.5 border-2 font-bold text-sm rounded-full hover:shadow-lg transition-all whitespace-nowrap flex items-center justify-center ${isScrolled ? 'border-[#0A1628] text-[#0A1628] hover:bg-[#0A1628] hover:text-white' : 'border-white text-white hover:bg-white hover:text-[#0A1628]'}`}
            >
              【無料】資料請求
            </a>
            <a 
              href="https://tri-line.ex-pa.jp/LR/XS1juv" 
              target="_blank" 
              rel="noopener noreferrer"
              id="cv-download"
              className="cv-download px-6 py-2.5 bg-gradient-to-r from-[#D4AF37] to-[#F4E4B8] text-[#0A1628] font-bold text-sm rounded-full hover:shadow-lg hover:shadow-[#D4AF37]/30 transition-all whitespace-nowrap flex items-center justify-center"
            >
              【公式LINE】で受け取る
            </a>
          </div>
          <div className="md:hidden flex items-center gap-2">
            <a
              href="https://carpartnershub.com/fm/29419/TjLxHRUK"
              target="_blank"
              rel="noopener noreferrer"
              className={`px-3 py-1.5 border-2 border-[#D4AF37] font-bold text-[10px] rounded-full whitespace-nowrap flex items-center justify-center transition-all ${isScrolled ? 'bg-white text-[#0A1628]' : 'bg-transparent text-white'}`}
            >
              資料請求
            </a>
            <a 
              href="https://tri-line.ex-pa.jp/LR/XS1juv" 
              target="_blank" 
              rel="noopener noreferrer"
              className="cv-download px-3 py-1.5 bg-gradient-to-r from-[#D4AF37] to-[#F4E4B8] text-[#0A1628] font-bold text-[10px] rounded-full whitespace-nowrap flex items-center justify-center"
            >
              【公式LINE】で受け取る
            </a>
          </div>
        </div>
      </nav>

      {/* ヒーローセクション */}
      <section className="relative min-h-screen flex items-center overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-[#0A1628] via-[#1A2F4A] to-[#0F1B2E]"></div>
        <div className="absolute right-0 top-0 w-[40%] h-full opacity-20 hidden md:block">
          <div className="absolute inset-0" style={{
            backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M30 0l25.98 15v30L30 60 4.02 45V15z' fill='none' stroke='%23D4AF37' stroke-width='0.5'/%3E%3C/svg%3E")`,
            backgroundSize: '60px 60px'
          }}></div>
        </div>
        
        <div className="relative max-w-[1600px] mx-auto px-4 md:px-8 py-20 md:py-32 w-full">
          <div className="max-w-[900px]">
            <div className="flex flex-col md:flex-row items-start gap-4 md:gap-6 mb-6 md:mb-8">
              <div className="w-1 h-12 md:h-20 bg-[#D4AF37]"></div>
              <div>
                <h1 className="text-3xl md:text-6xl font-bold text-white leading-tight mb-4 md:mb-6" style={{ fontFamily: "'Noto Serif JP', serif", letterSpacing: '0.05em' }}>
                  融資の壁を突破し、<br />資産5億円への道を拓く。
                </h1>
                <p className="text-lg md:text-xl text-[#B8C5D6] leading-relaxed mb-3 md:mb-4" style={{ lineHeight: '1.8' }}>
                  銀行が教えてくれない「財務再構築」という最短ルート
                </p>
                <p className="text-base md:text-lg text-[#B8C5D6] leading-relaxed" style={{ lineHeight: '1.8' }}>
                  「総合的判断」で融資が止まったオーナー様へ。<br />
                  個人の「隠れた与信」を呼び覚まし、投資家としてのステージを変える戦略的ファイナンス
                </p>
              </div>
            </div>
            
            <div className="space-y-3 md:space-y-4">
              <p className="text-base md:text-xl text-white font-medium leading-relaxed">
                なぜ、あなたの融資は止まったのか？<br className="md:hidden" />Web非公開の「融資突破スキーム」を公開
              </p>

              {/* デュアルCTAボタン */}
              <div className="flex flex-col gap-3 md:gap-4 max-w-[700px]">
                {/* ボタン1：資料請求（プライマリ） */}
                <a
                  href="https://carpartnershub.com/fm/29419/TjLxHRUK"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="group w-full bg-gradient-to-r from-[#D4AF37] to-[#F4E4B8] text-[#0A1628] font-bold rounded-full flex flex-col items-center justify-center px-5 md:px-10 py-4 md:py-5 hover:shadow-2xl hover:shadow-[#D4AF37]/40 transition-all duration-300 cursor-pointer"
                >
                  <span className="text-[#0A1628] font-bold text-[12px] md:text-lg leading-tight text-center whitespace-normal">
                    【無料】戦略ガイドブック(PDF)を請求する
                  </span>
                  <span className="text-[#0A1628]/70 font-medium text-[10px] md:text-sm mt-1 text-center">
                    30秒で完了！メールで即お届け
                  </span>
                </a>

                {/* ボタン2：LINE（セカンダリ） */}
                <a
                  href="https://tri-line.ex-pa.jp/LR/XS1juv"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="cv-download group w-full border-2 border-[#D4AF37] text-white font-bold rounded-full flex flex-col items-center justify-center px-5 md:px-10 py-4 md:py-5 hover:bg-[#D4AF37]/10 transition-all duration-300 cursor-pointer"
                >
                  <span className="font-bold text-[12px] md:text-lg leading-tight text-center whitespace-normal">
                    【限定特典】LINE追加で「解説音声」を受け取る
                  </span>
                  <span className="text-white/70 font-medium text-[10px] md:text-sm mt-1 text-center">
                    移動中に聴ける！18分でわかる攻略ポイント
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 問題提起セクション */}
      <section className="py-16 md:py-32 bg-[#FAFBFC]" id="about">
        <div className="max-w-[1600px] mx-auto px-4 md:px-8">
          <div className="text-center mb-12 md:mb-20">
            <div className="flex justify-center mb-4 md:mb-6">
              <div className="w-16 md:w-20 h-0.5 bg-[#D4AF37]"></div>
            </div>
            <h2 className="text-3xl md:text-5xl font-bold text-[#0A1628] mb-4 md:mb-6" style={{ fontFamily: "'Noto Serif JP', serif" }}>
              順調だった資産拡大が、<br />突然ストップしていませんか？
            </h2>
            <p className="text-base md:text-lg text-[#4A5568] max-w-[900px] mx-auto leading-relaxed">
              これまでの実績と高年収を武器に、数棟の物件を保有。<br />
              しかし今、銀行の反応が変わってきているはずです。
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-10 mb-12 md:mb-20">
            {[
              { num: '①', text: '「今回は総合的な判断でお見送りします」という曖昧な回答' },
              { num: '②', text: '「これ以上の融資は難しい」と遠回しに言われる閉塞感' },
              { num: '③', text: '理由は不明のまま、打開策が見つからない焦り' }
            ].map((item, index) => (
              <div key={index} className="bg-white rounded-xl border border-[#0A1628]/10 p-6 md:p-10 hover:shadow-xl transition-all duration-300">
                <div className="text-[#D4AF37] text-6xl md:text-8xl font-bold mb-4 md:mb-6 opacity-80" style={{ fontFamily: "'Noto Serif JP', serif" }}>
                  {item.num}
                </div>
                <p className="text-[#0A1628] text-base md:text-lg leading-relaxed">
                  {item.text}
                </p>
              </div>
            ))}
          </div>

          <div className="bg-white/5 rounded-2xl border border-[#D4AF37]/30 p-6 md:p-10 max-w-[1200px] mx-auto shadow-lg">
            <p className="text-[#0A1628] text-lg md:text-xl leading-relaxed">
              もし一つでも当てはまるなら、銀行開拓を続けるのは逆効果かもしれません。<br />
              <span className="font-bold text-[#D4AF37]">今あなたが直面しているのは、物件の問題ではなく「財務構造の限界」です。</span>
            </p>
          </div>
        </div>
      </section>

      {/* 理由説明セクション */}
      <section className="py-16 md:py-32 bg-[#0F1B2E]">
        <div className="max-w-[1600px] mx-auto px-4 md:px-8">
          <div className="text-center mb-12 md:mb-20">
            <h2 className="text-3xl md:text-5xl font-bold text-white mb-6 md:mb-8 leading-tight" style={{ fontFamily: "'Noto Serif JP', serif" }}>
              なぜ、年収が高くても融資が止まるのか。<br />
              それは「個人の信用力」だけで戦っているからです。
            </h2>
            <p className="text-lg md:text-xl text-[#B8C5D6] max-w-[1000px] mx-auto leading-relaxed">
              多くの投資家は、勤務先の信用や年収（いわゆる「属性」）を頼りに融資を引きます。<br />
              しかし、銀行には明確な貸出上限（与信枠）が存在し、ある一定ラインで必ずストップします。
            </p>
          </div>

          <div className="bg-white/5 rounded-2xl border border-[#D4AF37]/30 p-8 md:p-12 max-w-[1200px] mx-auto mb-12 md:mb-20">
            <p className="text-[#B8C5D6] text-base md:text-lg leading-relaxed mb-4 md:mb-6">
              ここで無理に「金利の高い銀行」や「地方銀行」へ無策に打診を繰り返すと、信用情報に傷がつくだけです。
            </p>
            <p className="text-[#B8C5D6] text-base md:text-lg leading-relaxed">
              多くの投資家は、「区分マンションで実績を作り、一棟アパートへ」という王道ルートを目指します。<br />
              しかし、この戦略には高所得の方ほど陥る<span className="text-[#D4AF37] font-bold">「優等生の罠」</span>が存在します。
            </p>
          </div>

          {/* フローチャート */}
          <div className="mb-12 md:mb-16">
            <h3 className="text-2xl md:text-3xl font-bold text-[#D4AF37] text-center mb-8 md:mb-12" style={{ fontFamily: "'Noto Serif JP', serif" }}>
              王道ルートの落とし穴（CFシミュレーション）
            </h3>
            
            <div className="flex flex-col md:flex-row items-center justify-center gap-4 md:gap-6 mb-8 md:mb-12">
              {[
                { title: '1〜2件目', subtitle: '都内区分マンション', price: '計6,500万円', status: 'プラマイゼロ', detail: '資産は増えたが、管理費等で手残りキャッシュは増えない', bank: '年収倍率（与信枠）を大きく消費' },
                { title: '3件目', subtitle: '一棟アパート', price: '8,000万円', status: '金利上昇により利益薄', detail: '金利2.5%超で返済比率が悪化', bank: '' },
                { title: '現在', subtitle: '融資ストップ', price: '総借入：1.45億円', status: '年間手残り：90万円のみ', detail: '借入規模の割に、返済原資（キャッシュ）が少なすぎる', bank: '返済能力評価（DCR）で否決' }
              ].map((step, index) => (
                <div key={index} className="flex flex-col md:flex-row items-center w-full md:w-auto">
                  <div className="bg-white/8 border-2 border-[#D4AF37] rounded-xl p-6 md:p-8 w-full md:w-[350px] hover:bg-white/12 transition-all">
                    <div className="flex items-center justify-center w-10 h-10 mb-4">
                      <i className={`${index === 0 ? 'ri-building-line' : index === 1 ? 'ri-home-4-line' : 'ri-alert-line'} text-2xl md:text-3xl text-[#D4AF37]`}></i>
                    </div>
                    <h4 className="text-white font-bold text-lg md:text-xl mb-2">{step.title}</h4>
                    <p className="text-[#D4AF37] text-sm mb-4">{step.subtitle}</p>
                    <div className="space-y-2 text-sm text-[#B8C5D6]">
                      <p><span className="text-[#D4AF37]">価格：</span>{step.price}</p>
                      <p><span className="text-[#D4AF37]">状態：</span>{step.status}</p>
                      <p className="text-xs leading-relaxed">{step.detail}</p>
                      {step.bank && <p className="text-xs text-[#D4AF37] font-bold">{step.bank}</p>}
                    </div>
                  </div>
                  {index < 2 && (
                    <div className="w-8 h-8 md:w-12 md:h-12 flex items-center justify-center rotate-90 md:rotate-0">
                      <i className="ri-arrow-right-line text-2xl md:text-3xl text-[#D4AF37]"></i>
                    </div>
                  )}
                </div>
              ))}
            </div>

            <div className="bg-[#3A3420] rounded-lg p-4 md:p-6 max-w-[1200px] mx-auto">
              <p className="text-[#E8DCC8] text-xs md:text-sm leading-relaxed">
                <span className="text-[#D4AF37] font-bold">※DCR（債務返済倍率）：</span>
                家賃収入から経費を引いた純利益が、返済額の何倍あるかを示す指標「1.3倍以上」が銀行融資の安全圏とされる目安
              </p>
            </div>
          </div>

          <div className="text-center">
            <p className="text-xl md:text-2xl text-white font-bold mb-4">必要なのは、無理な銀行開拓ではありません。</p>
            <p className="text-lg md:text-xl text-[#D4AF37]">銀行の審査基準（スコアリング）に合わせて、あなたの「財務諸表」自体を書き換えることです。</p>
          </div>
        </div>
      </section>

      {/* ブレイクスルー戦略セクション */}
      <section className="py-16 md:py-32 bg-white" id="strategy">
        <div className="max-w-[1600px] mx-auto px-4 md:px-8">
          <div className="text-center mb-12 md:mb-20">
            <div className="flex justify-center mb-4 md:mb-6">
              <div className="w-16 md:w-20 h-0.5 bg-[#D4AF37]"></div>
            </div>
            <h2 className="text-3xl md:text-5xl font-bold text-[#0A1628] mb-6 md:mb-8" style={{ fontFamily: "'Noto Serif JP', serif" }}>
              融資再開への「二段階ブレイクスルー」戦略
            </h2>
            <p className="text-lg md:text-xl text-[#4A5568] max-w-[1000px] mx-auto leading-relaxed">
              私たちは、個人の属性依存から脱却し、銀行が評価する「事業としての財務体質」を作ることで、<br />
              融資の可能性を最大化する専門チームです。
            </p>
          </div>

          <div className="space-y-12 md:space-y-16 mb-16 md:mb-24">
            {[
              {
                step: 'STEP 1',
                title: '個人の「未利用枠」を活用した戦略的ファイナンス',
                content: 'あなたには、まだ活用していない「隠れた与信枠」が存在します。この資金リソースを戦略的に引き出し、既存ローンの圧縮や手元資金（流動性）の強化に充てることで、銀行が重視する「返済能力評価（DCR）」を劇的に改善させます。'
              },
              {
                step: 'STEP 2',
                title: '個人から「法人」への信用移行',
                content: '個人の信用力が回復したタイミングで、資産管理法人の財務戦略を本格化。「個人の年収」に依存しない、事業としての「プロパー融資」が引ける体制を構築し、総資産5億円〜10億円の規模を目指します。'
              }
            ].map((item, index) => (
              <div key={index} className="flex flex-col md:flex-row items-start gap-6 md:gap-8">
                <div className="text-[#D4AF37] font-bold text-xl md:text-2xl whitespace-nowrap order-1 md:order-none" style={{ fontFamily: "'Noto Serif JP', serif" }}>
                  {item.step}
                </div>
                <div className="flex-1 bg-white rounded-2xl border-l-[5px] border-[#D4AF37] p-6 md:p-10 shadow-xl hover:shadow-2xl transition-all order-2 md:order-none">
                  <h3 className="text-xl md:text-2xl font-bold text-[#0A1628] mb-4 md:mb-6">{item.title}</h3>
                  <p className="text-base md:text-lg text-[#4A5568] leading-relaxed">{item.content}</p>
                </div>
              </div>
            ))}
          </div>

          {/* ステップアップ図解 */}
          <div className="bg-gradient-to-br from-[#FAFBFC] to-[#F8F6F0] rounded-3xl p-8 md:p-16">
            <h3 className="text-2xl md:text-3xl font-bold text-[#0A1628] text-center mb-12 md:mb-16" style={{ fontFamily: "'Noto Serif JP', serif" }}>
              ステップアップへの道筋
            </h3>
            
            <div className="w-full">
              <img 
                src="https://static.readdy.ai/image/2742a16e19e552b156a048de837759a0/8fe6e273b01eeac2f59f20ab90017929.png" 
                alt="ステップアップへの道筋" 
                className="w-full h-auto"
              />
            </div>
          </div>
        </div>
      </section>

      {/* 比較表セクション */}
      <section className="py-16 md:py-32 bg-[#F8F6F0]" id="comparison">
        <div className="max-w-[1600px] mx-auto px-4 md:px-8">
          <div className="text-center mb-12 md:mb-16">
            <h2 className="text-3xl md:text-5xl font-bold text-[#0A1628] mb-6 md:mb-8" style={{ fontFamily: "'Noto Serif JP', serif" }}>
              機能比較表
            </h2>
            <p className="text-base md:text-lg text-[#4A5568] max-w-[1000px] mx-auto leading-relaxed">
              以下は、一般的な不動産投資と、私たちが提供する仕組みを比較したものです。<br />
              どちらが優れているかではなく、「お金はどう残すか」という発想の違いをご覧ください。
            </p>
          </div>

          <div className="overflow-x-auto">
            <div className="min-w-[800px]">
              <table className="w-full bg-white rounded-2xl overflow-hidden shadow-xl">
                <thead>
                  <tr className="bg-[#0A1628]">
                    <th className="px-4 md:px-8 py-4 md:py-6 text-left text-white font-bold text-sm md:text-lg whitespace-nowrap">比較項目</th>
                    <th className="px-4 md:px-8 py-4 md:py-6 text-left text-white font-bold text-sm md:text-lg">これまでの一般的なアプローチ<br /><small>（多くの投資家・不動産業者の考え方）</small></th>
                    <th className="px-4 md:px-8 py-4 md:py-6 text-left text-white font-bold text-sm md:text-lg">本サービスが提供する財務戦略<br /><small>（銀行評価を最大化するBS構築）</small></th>
                  </tr>
                </thead>
                <tbody>
                  {[
                    { 
                      item: '最優先する指標', 
                      normal: '「表面利回り」と「積算評価」\n物件単体のスペックに依存し、実質のキャッシュフローを見落としがち', 
                      scheme: '「DCR（返済余裕率）」と「流動性」\n銀行が融資審査で最も重視する「安全性」と「返済能力」を基準にする' 
                    },
                    { 
                      item: '決算書の作り方', 
                      normal: '「節税（赤字）」が正義\n減価償却で利益を消し、税金を払わないことを目指す\n➡ 銀行評価は下がる', 
                      scheme: '「黒字化」と「キャッシュリッチ」\n戦略的に納税しつつ、手元資金を厚く見せる\n➡ 融資枠が拡大する' 
                    },
                    { 
                      item: '銀行開拓の手法', 
                      normal: '「数打ちゃ当たる」戦法\n手当たり次第に打診し、個人の属性（年収・勤務先）で頼み込む', 
                      scheme: '「逆算型」アプローチ\n銀行の審査基準（スコアリング）に合わせてBSを整形し、通るべくして通す' 
                    },
                    { 
                      item: '限界と未来', 
                      normal: '総借入 2〜3億円の壁\n個人の与信枠を使い切った時点で、融資が完全にストップし頭打ちになる', 
                      scheme: '総資産 5億円〜10億円の規模へ\n個人属性への依存から脱却し、法人プロパー融資へ移行して青天井に伸ばす' 
                    }
                  ].map((row, index) => (
                    <tr key={index} className={index % 2 === 0 ? 'bg-[#FDFCF8]' : 'bg-white'}>
                      <td className="px-4 md:px-8 py-4 md:py-6 bg-[#F4E4B8] text-[#0A1628] font-bold border-r border-[#D4AF37] whitespace-nowrap text-sm md:text-base">{row.item}</td>
                      <td className="px-4 md:px-8 py-4 md:py-6 text-[#4A5568] border-r border-[#D4AF37]/30 text-sm md:text-base whitespace-pre-line">{row.normal}</td>
                      <td className="px-4 md:px-8 py-4 md:py-6 text-[#0A1628] font-medium bg-[#FFF9E6] text-sm md:text-base whitespace-pre-line">{row.scheme}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          <div className="mt-12 md:mt-16 bg-gradient-to-r from-[#0A1628] to-[#1A2F4A] rounded-2xl p-8 md:p-12 text-center">
            <h3 className="text-2xl md:text-3xl font-bold text-[#D4AF37] mb-4 md:mb-6" style={{ fontFamily: "'Noto Serif JP', serif" }}>
              この「財務戦略」で得た信用こそが、<br />銀行を説得するための「最強の武器」になります
            </h3>
            <p className="text-base md:text-lg text-[#B8C5D6] leading-relaxed max-w-[1000px] mx-auto">
              ご覧いただいた通り、本スキームは単なる物件購入ではありません。銀行の審査ロジックを逆算し、あなたの財務諸表（BS）を「融資が出る形」に整形する戦略です。「DCRの改善」と「自己資金の厚み」。銀行が最も重視するこの2点を満たした時、あなたの個人信用は回復し、次なるステージへの扉が開きます。
            </p>
          </div>
        </div>
      </section>

      {/* CTA中間セクション */}
      <section className="py-16 md:py-24 bg-white">
        <div className="max-w-[1200px] mx-auto px-4 md:px-8">
          <div className="bg-gradient-to-br from-[#0A1628] to-[#1A2F4A] rounded-3xl p-8 md:p-16 text-center relative overflow-hidden">
            <div className="absolute inset-0 opacity-10 hidden md:block">
              <div className="absolute inset-0" style={{
                backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M30 0l25.98 15v30L30 60 4.02 45V15z' fill='none' stroke='%23D4AF37' stroke-width='0.5'/%3E%3C/svg%3E")`,
                backgroundSize: '60px 60px'
              }}></div>
            </div>
            
            <div className="relative">
              <h3 className="text-2xl md:text-4xl font-bold text-white mb-6 md:mb-8 leading-tight" style={{ fontFamily: "'Noto Serif JP', serif" }}>
                ここまで読んでいただいたあなたは、<br />きっと「次の一手」を真剣に考えている方だと思います。
              </h3>
              
              <p className="text-lg md:text-xl text-[#B8C5D6] mb-6 md:mb-8">もし、これまでにこんな思いをお持ちであればー</p>
              
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6 max-w-[900px] mx-auto mb-8 md:mb-12">
                {[
                  '最近は融資が通らなくて動けない',
                  '物件管理の手間がストレスになっている',
                  '利益が出ても、なぜかお金が残らない',
                  'もう節税はやりつくした気がする',
                  '次のステージに進みたいけど、何からはじめればいいのかわからない'
                ].map((text, index) => (
                  <div key={index} className="flex items-start gap-3 text-left">
                    <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 mt-1">
                      <i className="ri-checkbox-circle-fill text-lg md:text-xl text-[#D4AF37]"></i>
                    </div>
                    <span className="text-white text-sm md:text-base">{text}</span>
                  </div>
                ))}
              </div>
              
              <p className="text-xl md:text-2xl text-[#D4AF37] font-bold mb-8 md:mb-10">
                ひとつでも当てはまるなら、今が「投資戦略」を根本から見直すタイミングです。
              </p>
              
              <div className="mb-6 md:mb-8 text-[#B8C5D6] text-xs md:text-sm space-y-2 text-left max-w-[700px] mx-auto">
                <p className="font-bold text-base mb-3">① 「融資の壁」突破・戦略ガイドブック（PDF）</p>
                <p className="pl-4">✓ 不動産オーナーのための「BS・キャッシュフロー」改善戦略</p>
                <p className="pl-4">✓ 支援の具体的な内容とメカニズム</p>
                <p className="font-bold text-base mt-4 mb-3">② 限定公開：解説音声</p>
                <p className="pl-4">✓ 「移動中に聴ける」資料の重要ポイント18分解説</p>
                <p className="pl-4">✓ なぜ今、不動産だけでは「詰まる」のか？音声だから話せる裏側</p>
              </div>

              {/* デュアルCTAボタン */}
              <div className="flex flex-col md:flex-row gap-4 md:gap-6 max-w-[900px] mx-auto">
                {/* ボタン1：資料請求（プライマリ） */}
                <a
                  href="https://carpartnershub.com/fm/29419/TjLxHRUK"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="group flex-1 bg-gradient-to-r from-[#D4AF37] to-[#F4E4B8] text-[#0A1628] font-bold rounded-full flex flex-col items-center justify-center px-5 md:px-8 py-4 md:py-5 hover:shadow-2xl hover:shadow-[#D4AF37]/40 transition-all duration-300 cursor-pointer"
                >
                  <span className="text-[#0A1628] font-bold text-[12px] md:text-base leading-tight text-center whitespace-normal">
                    銀行攻略の「数値根拠資料」をダウンロードする
                  </span>
                </a>

                {/* ボタン2：LINE（セカンダリ） */}
                <a
                  href="https://tri-line.ex-pa.jp/LR/XS1juv"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="cv-download group flex-1 border-2 border-[#D4AF37] text-white font-bold rounded-full flex flex-col items-center justify-center px-5 md:px-8 py-4 md:py-5 hover:bg-[#D4AF37]/10 transition-all duration-300 cursor-pointer"
                >
                  <span className="font-bold text-[12px] md:text-base leading-tight text-center whitespace-normal">
                    【LINE追加特典】資料解説音声を今すぐ聴く
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* YouTubeセクション */}
      <section className="py-16 md:py-32 bg-[#FAFBFC]">
        <div className="max-w-[1600px] mx-auto px-4 md:px-8">
          <div className="text-center mb-12 md:mb-16">
            <div className="inline-flex items-center gap-2 md:gap-3 border-2 border-[#D4AF37] text-[#0A1628] px-4 md:px-6 py-2 md:py-3 rounded-full mb-6 md:mb-8">
              <i className="ri-youtube-fill text-xl md:text-2xl text-[#D4AF37]"></i>
              <span className="font-bold text-sm md:text-base">登録者数2.36万人</span>
            </div>
            <h2 className="text-2xl md:text-4xl font-bold text-[#0A1628] mb-4 md:mb-6" style={{ fontFamily: "'Noto Serif JP', serif" }}>
              財務・融資の「ロジック」を自らが解説しています。
            </h2>
            <p className="text-base md:text-lg text-[#4A5568] max-w-[900px] mx-auto leading-relaxed mb-3 md:mb-4" style={{ fontSize: '15.5px', letterSpacing: '-0.01em' }}>
              財務系コンサルティングYouTuberの武智 剛と代表取締役の佐々木 雄哉の2人を中心に、登録者1万人超、数百本の動画で「不動産投資」「可動産」「お金の考え方」を発信し続けています。財務に基づいた資金戦略やBS（貸借対照表）の考え方を公開。不動産投資の知見に加え、私たちが開発した「可動産」という独自スキームについても解説。不動産に関心のあるオーナー様であれば、資産形成の新たなヒントが見つかるはずです。
            </p>
            <p className="text-sm md:text-base text-[#4A5568]">
              これまで <span className="text-[#D4AF37] font-bold text-lg md:text-xl">360本</span> の動画を投稿
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8 mb-8 md:mb-12">
            {[
              { url: 'https://www.youtube.com/embed/U8_9eBwFZyM' },
              { url: 'https://www.youtube.com/embed/9uUMCgUkqWE' },
              { url: 'https://www.youtube.com/embed/K1TuQrwQKnc' }
            ].map((video, index) => (
              <div key={index} className="bg-white rounded-xl overflow-hidden shadow-lg hover:shadow-2xl transition-all">
                <div className="relative w-full h-48 md:h-64">
                  <iframe
                    src={video.url}
                    className="w-full h-full"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  ></iframe>
                </div>
              </div>
            ))}
          </div>

          <div className="text-center mb-8 md:mb-12">
            <a 
              href="https://www.youtube.com/@banto_banto" 
              target="_blank" 
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 md:gap-3 px-6 md:px-8 py-3 md:py-4 bg-[#D4AF37] text-[#0A1628] font-bold text-base md:text-lg rounded-full hover:shadow-xl hover:shadow-[#D4AF37]/40 transition-all whitespace-nowrap"
            >
              <i className="ri-youtube-fill text-xl md:text-2xl"></i>
              <span>公式チャンネルはこちら</span>
            </a>
          </div>

          <div className="mt-12 md:mt-16 bg-gradient-to-r from-[#0A1628] to-[#1A2F4A] rounded-2xl p-8 md:p-12">
            <p className="text-lg md:text-xl text-white leading-relaxed text-center max-w-[1000px] mx-auto">
              私たちは、あなたに「可動産」を売りたいわけではありません。可動産という「機能」を使って、あなたのBS（貸借対照表）を整形したいのです。不動産が増えるほど、BSは重く、硬直化していきます。そこに「流動性が高く」「償却が早い」資産を数％混ぜるだけで、全体の財務健全性は劇的に向上します。<br />
              <span className="text-[#D4AF37] font-bold">これは投資商品の購入ではなく、ポートフォリオのリバランス（再構築）です。</span>
            </p>
          </div>
        </div>
      </section>

      {/* お客様の声セクション */}
      <section className="py-16 md:py-32 bg-white" id="voice">
        <div className="max-w-[1600px] mx-auto px-4 md:px-8">
          <div className="text-center mb-12 md:mb-16">
            <div className="flex justify-center mb-4 md:mb-6">
              <div className="w-10 h-10 md:w-12 md:h-12 bg-[#F8F6F0] rounded-full flex items-center justify-center flex-shrink-0">
                <i className="ri-user-fill text-2xl md:text-3xl text-[#D4AF37]"></i>
              </div>
            </div>
            <h2 className="text-3xl md:text-5xl font-bold text-[#0A1628]" style={{ fontFamily: "'Noto Serif JP', serif" }}>
              お客様の声
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12">
            {[
              {
                name: 'T.T様',
                age: '32歳',
                gender: '男性',
                job: '医師',
                q1: '加盟を決めた理由は？',
                a1: '返済比率が40%を超え「もう借りられない」と諦めていましたが、不動産とは異なる「別枠融資」を使える点に驚きました。',
                q2: '加盟するにあたり、疑問、不安だった点は？',
                a2: 'すでに与信を結構使っていたので融資を受けられるかどうか不安だった'
              },
              {
                name: 'J.T様',
                age: '45歳',
                gender: '男性',
                job: '経営者・役員',
                q1: '加盟を決めた理由は？',
                a1: '地銀や信金の枠を使い切り手詰まりでしたが、「既存の不動産融資枠を圧迫しない」という仕組みに可能性を感じました。',
                q2: '加盟するにあたり、疑問、不安だった点は？',
                a2: 'いつまで続けるのか。そもそもお金を借りれるのかと思っていました。面談で詳しい話を聞いて払拭できました。'
              },
              {
                name: 'K.N様',
                age: '46歳',
                gender: '女性',
                job: '経営者・役員',
                q1: '加盟を決めた理由は？',
                a1: '直近の物件評価が伸びず審査落ちが続いていましたが、「不動産の評価基準に縛られない」この手法ならいけると確信しました。',
                q2: '加盟するにあたり、疑問、不安だった点は？',
                a2: 'すでに地銀と信金で融資枠を使い切っていたため、「これ以上借りられるのか？」と半信半疑でした。'
              }
            ].map((review, index) => (
              <div key={index} className="bg-white border border-[#D4AF37] rounded-2xl p-6 md:p-10 shadow-lg hover:shadow-xl transition-all">
                <div className="flex flex-col md:flex-row items-start gap-4 mb-6">
                  <div className="w-10 h-10 md:w-12 md:h-12 bg-[#F8F6F0] rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-user-fill text-2xl md:text-3xl text-[#D4AF37]"></i>
                  </div>
                  <div className="flex-1">
                    <h3 className="text-lg md:text-xl font-bold text-[#0A1628] mb-3 md:mb-4">{review.name}</h3>
                    <p className="text-[#4A5568] text-xs md:text-sm">{review.age} / {review.gender} / {review.job}</p>
                  </div>
                </div>
                
                <div className="space-y-4">
                  <div>
                    <p className="text-[#0A1628] font-bold text-sm md:text-base mb-2">Q. {review.q1}</p>
                    <p className="text-[#4A5568] text-sm md:text-base leading-relaxed">A. {review.a1}</p>
                  </div>
                  <div>
                    <p className="text-[#0A1628] font-bold text-sm md:text-base mb-2">Q. {review.q2}</p>
                    <p className="text-[#4A5568] text-sm md:text-base leading-relaxed">A. {review.a2}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FAQセクション */}
      <section className="py-16 md:py-32 bg-[#FAFBFC]">
        <div className="max-w-[1200px] mx-auto px-4 md:px-8">
          <div className="text-center mb-12 md:mb-16">
            <h2 className="text-3xl md:text-5xl font-bold text-[#0A1628] mb-4" style={{ fontFamily: "'Noto Serif JP', serif" }}>
              よくあるご質問
            </h2>
          </div>

          <div className="space-y-4 md:space-y-6">
            {[
              {
                q: 'どんな人に向いていますか？',
                a: '特に「減価償却切れ」によるデッドクロス対策や、次期融資に向けた自己資本比率の改善をお考えのオーナー様に最適です'
              },
              {
                q: '節税商品とはどう違うのですか？',
                a: '一時的な控除ではなく、資金構造そのものを見直す設計を行っています'
              },
              {
                q: 'リスクはありますか？',
                a: '投資商品ではなく、制度に基づいた合法的な資金構成の考え方です。リスクや費用はすべて明示します'
              },
              {
                q: '個別で相談できますか？',
                a: 'はい。資料をお読みいただいた上で、ご希望の方に限定してご案内しています'
              }
            ].map((faq, index) => (
              <div key={index} className="bg-white rounded-xl p-6 md:p-8 shadow-md hover:shadow-lg transition-all">
                <div className="flex flex-col md:flex-row items-start gap-4">
                  <div className="w-10 h-10 md:w-12 md:h-12 bg-[#D4AF37] rounded-full flex items-center justify-center flex-shrink-0">
                    <span className="text-white font-bold text-lg md:text-xl">Q</span>
                  </div>
                  <div className="flex-1">
                    <h3 className="text-lg md:text-xl font-bold text-[#0A1628] mb-3 md:mb-4">{faq.q}</h3>
                    <div className="flex flex-col md:flex-row items-start gap-4">
                      <div className="w-10 h-10 md:w-12 md:h-12 bg-[#0F1B2E] rounded-full flex items-center justify-center flex-shrink-0">
                        <span className="text-[#D4AF37] font-bold text-lg md:text-xl">A</span>
                      </div>
                      <p className="text-[#4A5568] text-base md:text-lg leading-relaxed flex-1">{faq.a}</p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ダウンロードフォームセクション */}
      <section className="py-16 md:py-32 bg-gradient-to-br from-[#0A1628] via-[#1A2F4A] to-[#0F1B2E]" id="download-form">
        <div className="max-w-[1200px] mx-auto px-4 md:px-8">
          <div className="text-center mb-12 md:mb-16">
            <h2 className="text-3xl md:text-5xl font-bold text-white mb-6 md:mb-8 leading-tight" style={{ fontFamily: "'Noto Serif JP', serif" }}>
              Web上では書ききれない、<br />銀行攻略の「数値根拠」と「ロジック」があります。
            </h2>
            <p className="text-lg md:text-xl text-[#B8C5D6] leading-relaxed max-w-[900px] mx-auto mb-3 md:mb-4">
              本スキームは、金融機関ごとの最新の審査傾向に合わせて設計する必要があります。そのため、最新の数値をまとめた「攻略資料」は資料請求フォームにて。資料をより深く理解するための「特別解説音声」は公式LINE限定特典としてお渡ししています。
            </p>
            <p className="text-xs md:text-sm text-[#B8C5D6]">
              ※本資料では、実際のビフォーアフター事例や、具体的なファイナンス手法を公開しています。<br />
              ※個別面談をご希望の方も、まずは本資料で概要をご確認ください。
            </p>
          </div>

          <div className="bg-white rounded-3xl p-8 md:p-12 shadow-2xl max-w-[800px] mx-auto">
            <div className="mb-6 md:mb-8 text-[#4A5568] text-xs md:text-sm space-y-2 text-left max-w-[700px] mx-auto">
              <p className="font-bold text-base mb-3">① 「融資の壁」突破・戦略ガイドブック（PDF）</p>
              <p className="pl-4">✓ 不動産オーナーのための「BS・キャッシュフロー」改善戦略</p>
              <p className="pl-4">✓ 支援の具体的な内容とメカニズム</p>
              <p className="font-bold text-base mt-4 mb-3">② 限定公開：解説音声</p>
              <p className="pl-4">✓ 「移動中に聴ける」資料の重要ポイント18分解説</p>
              <p className="pl-4">✓ なぜ今、不動産だけでは「詰まる」のか？音声だから話せる裏側</p>
            </div>

            {/* デュアルCTAボタン */}
            <div className="flex flex-col md:flex-row gap-4 md:gap-6">
              {/* ボタン1：資料請求（プライマリ） */}
              <a
                href="https://carpartnershub.com/fm/29419/TjLxHRUK"
                target="_blank"
                rel="noopener noreferrer"
                className="group flex-1 bg-gradient-to-r from-[#D4AF37] to-[#F4E4B8] text-[#0A1628] font-bold rounded-full flex items-center justify-center px-5 md:px-8 py-4 md:py-5 hover:shadow-2xl hover:shadow-[#D4AF37]/40 transition-all duration-300 cursor-pointer"
              >
                <span className="text-[#0A1628] font-bold text-[12px] md:text-base leading-tight text-center whitespace-normal">
                  銀行攻略の「数値根拠資料」をダウンロードする
                </span>
              </a>

              {/* ボタン2：LINE（セカンダリ） */}
              <a
                href="https://tri-line.ex-pa.jp/LR/XS1juv"
                target="_blank"
                rel="noopener noreferrer"
                className="cv-download group flex-1 border-2 border-[#D4AF37] text-[#0A1628] font-bold rounded-full flex items-center justify-center px-5 md:px-8 py-4 md:py-5 hover:bg-[#D4AF37]/10 transition-all duration-300 cursor-pointer"
              >
                <span className="font-bold text-[12px] md:text-base leading-tight text-center whitespace-normal">
                  【LINE追加特典】資料解説音声を今すぐ聴く
                </span>
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* フッター */}
      <footer className="bg-[#0A1628] text-white py-12 md:py-20 relative overflow-hidden">
        <div className="absolute inset-0 opacity-5 hidden md:block">
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-[#1A2F4A] text-[300px] font-bold whitespace-nowrap" style={{ fontFamily: "'Noto Serif JP', serif" }}>
            BANTO
          </div>
        </div>

        <div className="relative max-w-[1600px] mx-auto px-4 md:px-8">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8 md:gap-12 mb-12 md:mb-16">
            <div>
              <div className="flex items-center gap-2 md:gap-3 mb-4 md:mb-6">
                <div className="w-8 h-8 md:w-12 md:h-12 flex items-center justify-center">
                  <img src="https://static.readdy.ai/image/2742a16e19e552b156a048de837759a0/721313bee9e9ad322b7dd57b3ac95a66.png" alt="万燈ロゴ" className="w-full h-full object-contain" />
                </div>
                <span className="text-2xl md:text-3xl font-bold" style={{ fontFamily: "'Noto Serif JP', serif" }}>万燈</span>
              </div>
              <p className="text-[#B8C5D6] text-xs md:text-sm leading-relaxed">
                財務再構築を通じて、<br />
                投資家の新しいステージを創造する
              </p>
            </div>

            <div>
              <h3 className="text-[#D4AF37] font-bold mb-4 md:mb-6 text-xs md:text-sm">サービス</h3>
              <ul className="space-y-2 md:space-y-3">
                <li><a href="#about" className="text-[#B8C5D6] text-xs md:text-sm hover:text-[#D4AF37] transition-colors">サービス概要</a></li>
                <li><a href="#strategy" className="text-[#B8C5D6] text-xs md:text-sm hover:text-[#D4AF37] transition-colors">戦略</a></li>
                <li><a href="#comparison" className="text-[#B8C5D6] text-xs md:text-sm hover:text-[#D4AF37] transition-colors">比較表</a></li>
                <li><a href="#voice" className="text-[#B8C5D6] text-xs md:text-sm hover:text-[#D4AF37] transition-colors">お客様の声</a></li>
                <li><a href="#download-form" className="text-[#B8C5D6] text-xs md:text-sm hover:text-[#D4AF37] transition-colors">資料ダウンロード</a></li>
              </ul>
            </div>

            <div>
              <h3 className="text-[#D4AF37] font-bold mb-4 md:mb-6 text-xs md:text-sm">フォローする</h3>
              <div className="space-y-3 md:space-y-4">
                <a href="https://www.youtube.com/@banto_banto" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 md:gap-3 text-[#B8C5D6] hover:text-[#D4AF37] transition-colors">
                  <div className="w-8 h-8 md:w-10 md:h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-[#D4AF37] transition-colors">
                    <i className="ri-youtube-fill text-lg md:text-xl"></i>
                  </div>
                  <span className="text-xs md:text-sm">YouTube</span>
                </a>
              </div>
            </div>

            <div>
              <h3 className="text-white font-bold mb-3 md:mb-4 text-sm md:text-base">会社情報</h3>
              <div className="space-y-2 md:space-y-3 text-[#B8C5D6] text-xs leading-relaxed">
                <p><span className="text-[#D4AF37]">会社名：</span>株式会社万燈</p>
                <p><span className="text-[#D4AF37]">代表者：</span>佐々木 雄哉</p>
                <p><span className="text-[#D4AF37]">資本金：</span>9,990万円</p>
                <p><span className="text-[#D4AF37]">電話番号：</span>03-6823-4427</p>
                <p><span className="text-[#D4AF37]">設立：</span>令和3年12月15日</p>
              </div>
            </div>
          </div>

          <div className="border-t border-[#D4AF37]/20 pt-6 md:pt-8">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
              <div>
                <p className="text-[#B8C5D6] text-xs mb-2"><span className="text-[#D4AF37]">本社：</span></p>
                <p className="text-[#B8C5D6] text-xs">〒160-0023 東京都新宿区西新宿6丁目15-1<br />セントラルパークタワー ラ・トゥール新宿5階</p>
              </div>
              <div>
                <p className="text-[#B8C5D6] text-xs mb-2"><span className="text-[#D4AF37]">事業所：</span></p>
                <p className="text-[#B8C5D6] text-xs mb-2">沖縄店：〒904-0116 沖縄県中頭郡北谷町北谷2-1-5<br />TEL.098-983-7011 / FAX.098-983-7018</p>
                <p className="text-[#B8C5D6] text-xs">宮古島店：〒906-0012 宮古島市平良西里1425-1</p>
              </div>
            </div>

            <div className="mb-6 md:mb-8">
              <p className="text-[#B8C5D6] text-xs">
                <span className="text-[#D4AF37]">古物営業法に基づく表記：</span>東京都公安委員会 第304362517765号
              </p>
            </div>

            <div className="flex flex-col md:flex-row items-center justify-between pt-6 md:pt-8 border-t border-[#D4AF37]/20 gap-4">
              <p className="text-[#B8C5D6] text-xs text-center md:text-left">
                © 2024 株式会社万燈. All rights reserved.
              </p>
              <a href="https://readdy.ai/?origin=logo" target="_blank" rel="noopener noreferrer" className="text-[#B8C5D6] text-xs hover:text-[#D4AF37] transition-colors">
                Powered by Readdy
              </a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
